// ProtectedRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import { isTokenExpired } from "../helpers/AppCode";
import useNotification from "src/store/Notifications/useNotification";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
  isAuthProtected: boolean;
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ isAuthProtected, children }) => {
  const navigate = useNavigate();
  const tokenAuthUser = localStorage.getItem(`${process.env.REACT_APP_BASENAME}_authUser`);
  const { setIsNotificationVisible } = useNotification();

  useEffect(() => {
    setIsNotificationVisible(false);
  },[navigate])
  

  if (isAuthProtected && isTokenExpired(tokenAuthUser)) {
    return (
      <Navigate
        to={{
          pathname: "/login",
        }}
        replace
      />
    );
  }

  return <>{children || <Outlet />}</>;
};

export default ProtectedRoute;
